import { Button, makeStyles} from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { ApplicationUserContext } from '../../../config/Context';
import { IServiceUserContent } from '../../../datasolvr/ServicesFacade';
import { InputContainer } from '../../../components/ui/InputContainer';
import { InputField } from '../../../components/ui/InputField';
import { CancelCrudButtons } from '../../../components/ui/CancelCrudButtons';
import { IResetPasswordUser } from '../../../interface/interface';
import { planEatApi } from '../../../planEatApi/PlanEatApi';


const useStyles = makeStyles((theme: any) => ({
    container: {
        width: '100%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        marginTop: 30,
        padding: 30
    },
    twoItemRow: {
        display: 'grid',
        gridTemplateColumns: '45% 45%',
        gridTemplateRow: '100%',
        justifyContent: 'space-between',
        columnGap: 15
    },
    oneItemRow: {
        paddingTop: 40,
        display: 'grid',
        gridTemplateColumns: '100%',
        gridTemplateRow: '100%'
    },
    buttonContainer: {
        display: 'grid',
        justifyContent: 'flex-end',
        gridTemplateColumns: '25% 25%',
        gridTemplateRow: '100%',
        columnGap: 15,
        width: '100%',
    },
}));


export const AdminProfile: React.FC = () => {
    const classes = useStyles();
    const applicationUserContext = useContext(ApplicationUserContext);
    const history = useHistory()

    // State
    const [serviceUser, setServiceUser] = useState<IServiceUserContent>();
    const [editCredentialsHidden, setEditCredentialsHidden] = useState(true);
    const [editUserInfoHidden, setEditUserInfoHidden] = useState(true);
    const [newCredentials, setNewCredentials] = useState<IResetPasswordUser>({
        newPassword: '',
        confirmNewPassword: '',
        showPassword: false
    });

    useEffect(() => {
        if(applicationUserContext?.applicationServiceUser){
            setServiceUser({
                id : applicationUserContext?.applicationServiceUser.content.id,
                data_raw: applicationUserContext?.applicationServiceUser.content.data_raw,
                description:applicationUserContext?.applicationServiceUser.content.description, 
                name: applicationUserContext?.applicationServiceUser.content.name,
            })
        }
    },[applicationUserContext?.applicationServiceUser])

    function updateUser(){
        if(serviceUser){
            planEatApi.postServiceUser(serviceUser)
            .then(() => {
                toast.success("Admin was updated")
                setEditUserInfoHidden(true);
            })
            .catch(e  => {
                toast.error("Failed updating admin")
            })
        }
    }

    function updateLogin(){
        if(serviceUser){
            if(newCredentials.newPassword === newCredentials.confirmNewPassword){
                if(serviceUser.data_raw?.hash){
                    serviceUser.data_raw.hash = newCredentials.newPassword;
                    planEatApi.postServiceUser(serviceUser)
                    .then(response => {
                        toast.success("Admin password was updated")
                        setEditCredentialsHidden(true);
                        localStorage.clear();
                        history.push("/")
                    })
                    .catch(e  => {
                        toast.error("Failed updating admin password")
                    })
                }
            } else {
                toast.error("Passwords didn't match")
            }
        }
    }

    const handleEmailChange = (email: string) => {
        if(serviceUser && serviceUser.data_raw){
            // Tmp user
            var tmpServiceUserInfo : IServiceUserContent = {
                id : serviceUser.id,
                data_raw: {
                    authorization: serviceUser.data_raw?.authorization,
                    hash: serviceUser.data_raw?.hash,
                    groups: serviceUser.data_raw?.groups,
                    tags: serviceUser.data_raw?.tags,
                    email: email,
                    options: serviceUser.data_raw?.options,
                },
                description:serviceUser.description, 
                name: serviceUser.name,
            }
            setServiceUser(tmpServiceUserInfo)
        }
    }

    const handleChange = (prop: keyof IServiceUserContent) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if(serviceUser){
        setServiceUser({ ...serviceUser, [prop]: event.target.value });
        }
    };


    const handlePasswordChange = (prop: keyof IResetPasswordUser) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewCredentials({ ...newCredentials, [prop]: event.target.value });
    };

    return (
        <div>
            {
                serviceUser &&
                <div className={classes.container}>
                    {
                        editCredentialsHidden ?
                        <div>
                            <InputContainer>
                                <div>
                                    <InputField
                                    fullWidth
                                    variant='outlined'
                                    label="Admin name"
                                    value={serviceUser.name}
                                    onChange={handleChange("name")}
                                    disabled={editUserInfoHidden}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}/>
                                </div>
                                <div>
                                    <InputField
                                        fullWidth
                                        variant='outlined'
                                        label="Admin Email"
                                        value={serviceUser.data_raw?.email}
                                        onChange={(e) => {handleEmailChange(e.target.value)}}
                                        disabled={editUserInfoHidden}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}/>
                                </div>
                            </InputContainer>
                            {
                                !editUserInfoHidden ?
                                <CancelCrudButtons 
                                    hidden={editUserInfoHidden} 
                                    setHidden={setEditUserInfoHidden} 
                                    isDelete={false} 
                                    postEntity={updateUser}
                                    postButtonText={"Update User Information"}/>
                                :
                                <div className={classes.oneItemRow}>
                                    <div className={classes.buttonContainer}>
                                        <Button variant="contained" onClick={() => {setEditCredentialsHidden(false)}}>
                                            Edit Login
                                        </Button>
                                        <Button variant="contained" onClick={() => {setEditUserInfoHidden(false)}}>
                                            Edit User
                                        </Button>
                                    </div>
                                </div>
                            }
                        </div>
                        :
                        <div>
                            <InputContainer>
                                <InputField
                                    fullWidth
                                    variant="outlined"
                                    type="password"
                                    label="New Password"
                                    value={newCredentials.newPassword}
                                    onChange={handlePasswordChange('newPassword')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}/>
                                <InputField
                                    fullWidth
                                    variant="outlined"
                                    type="password"
                                    label="Confirm new password"
                                    value={newCredentials.confirmNewPassword}
                                    onChange={handlePasswordChange('confirmNewPassword')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}/>

                            </InputContainer>
                            <CancelCrudButtons 
                                hidden={editCredentialsHidden} 
                                setHidden={setEditCredentialsHidden} 
                                isDelete={false} 
                                postEntity={updateLogin}
                                postButtonText={"Update Login"}/>
                        </div>
                    }
                </div>
            }
        </div>
    );
}